import './buttons.css';
import {Portal} from 'react-portal';
import PropTypes from 'prop-types';
import React, {ReactElement, useContext, useEffect, useMemo, useRef, useState} from 'react';
import {usePopper} from 'react-popper';

import userImage from '../img/user.svg';
import userImageSelected from '../img/user_selected.svg';

import Menu, {IfmsMenuItem} from './menu/Menu';
import DashboardCustomButton from './DashboardCustomButton';
import ApplicationContext from '../ApplicationContext';
import config from '../config';
import { useAppDispatch, useAppSelector } from '../app/hooks';
import { changeUserIconUrl } from '../features/loginSlice';
import { User } from '../ifmsTypes';
import LetteredAvatar from '../components/common/utils/letteredAvatar';

export interface UserButtonItem {
  label: React.ReactNode|string|undefined,
  separator?: boolean,
  newCol?: boolean,
  popupComponent?: ReactElement,
  popupWidth?: number,
  popupLabel?: React.ReactNode|string|undefined,
  [x:string]: any,
  hidden?: boolean,
  link?: string,
  disabeld? : boolean
};
export const borderColors = ['#0079A4', '#B5038F', '#FF3300', '#89C064', '#00B0F0', '#007BFF'];

export function splitMenuItemsIntoSections(actionButtonItems: UserButtonItem[]): IfmsMenuItem[][][] {
  const result: IfmsMenuItem[][][] = [[[]]]
  actionButtonItems.forEach((item, index) => {
    if (item.hidden) return
    result[result.length - 1][result[result.length - 1].length - 1].push({
      text: item.label,
      // separator: item.separator,
      separator: false,
      selected: false,
      index,
      disabled:item?.disabeld ?? false,
      icon:item?.icon ?? null,
      icon2:item?.icon2 ?? null
    });

    if(item.newCol && index !== actionButtonItems.length - 1) {
      result.push([]);
    }
    if(item.separator && index !== actionButtonItems.length - 1) {
      result[result.length - 1].push([]);
    }
  })
  return result;
} 

function ActionButton({
  items = [],
  action = 'click',
  children = undefined,
  onItemSelected = () => {},
  height = undefined,
  variant = 'plain',
  user
}: {
  items?: Array<UserButtonItem>,
  action?: 'click'|'hover'|'rightClick',
  hideCaret?: boolean,
  onItemSelected?: (x:UserButtonItem) => void,
  children?: React.ReactChild|React.ReactNode|string|null|undefined,
  height?: string|undefined,
  variant?: 'plain'|'highlight',
  user: User|null,
}) {
  const appContext = useContext(ApplicationContext);
  const [menuVisible, _setMenuVisible] = useState(false);
  const [referenceElement, setReferenceElement] = useState<HTMLSpanElement|null>(null);
  const [popperElement, setPopperElement] = useState<HTMLDivElement|null>(null);
  const [arrowElement, setArrowElement] = useState<HTMLDivElement|null>(null);
  const { styles, attributes } = usePopper(referenceElement, popperElement, {
    modifiers: [
      {
        name: 'arrow',
        options: {
          element: arrowElement,
        }
      }],
  });

  const menuContainerRef = useRef<HTMLDivElement>(null);
  const buttonRef = useRef<HTMLButtonElement>(null);
  const openRef = useRef(false);
  const clickForMenuCloseRef = useRef(false);
  const userState = useAppSelector(state => state.user);
  const dispatch = useAppDispatch();
  
  useEffect(() => {
    async function executeAsyncFunc(){
      await getUserIcon(appContext.user?.id ?? '');
    }
    executeAsyncFunc();

    document.addEventListener('click', handleClickOutsideMenu, true);
    //document.addEventListener('mousemove', mouseMove, true);
    return () => {
      document.removeEventListener('click', handleClickOutsideMenu, true);
      //document.removeEventListener('mousemove', mouseMove, true);
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  async function getUserIcon(userID: string) {
    if (!userID) return;

    const userToken = appContext.user ? appContext.user.accessToken ?? '' : '';
  
    fetch(`${config.serverUrl}user/signDownload?userID=${userID}&isGetIcon=true`,
      { method: 'GET',
        headers: {
          'Authorization': `Bearer ${userToken}` 
        }
      }
    )
      .then(response => {
        if (response.ok) {
          response.blob().then(blob => {
            if (blob.size > 0) {
              const url = window.URL.createObjectURL(blob);
              dispatch(changeUserIconUrl({url}));
            }
          });
        }
      })
    .catch(error => {});
  }

  //function mouseMove(e:MouseEvent) {
    // if (action !== 'hover') {
    //   return;
    // }

    // const mX = e.clientX;
    // const mY = e.clientY;

    // let overButton = false;
    // let overMenu = false;

    // if (buttonRef && buttonRef.current) {
    //   const bc = buttonRef.current.getBoundingClientRect();
    //   overButton = mX >= bc.x && mX <= bc.right && mY >= bc.top && mY <= bc.bottom;
    // }

    // if (menuContainerRef && menuContainerRef.current) {
    //   const mc = menuContainerRef.current.getBoundingClientRect();
    //   overMenu = mX >= mc.x && mX <= mc.right && mY >= mc.top - 10 && mY <= mc.bottom;
    // }

    // const showMenu = overButton || overMenu;
    // if (showMenu !== openRef.current) {
    //   setMenuVisible(showMenu);
    // }
  //}

  function handleClickOutsideMenu(e:MouseEvent) {
    // if (action === 'hover') {
    //   return;
    // }
    clickForMenuCloseRef.current = false;

    if (openRef.current && menuContainerRef && menuContainerRef.current) {
      const target = e.target as HTMLElement;
      const shouldClose = !menuContainerRef.current.contains(target);

      if (shouldClose) {
        setMenuVisible(false);
        clickForMenuCloseRef.current = true;
      }
    }
  }

  function setMenuVisible(v:boolean) {
    openRef.current = v;
    _setMenuVisible(v);
  }

  function onMenuItemSelected(item:IfmsMenuItem) {
    if (item.index !== undefined && item.index >= 0 && item.index <= items.length) {
      onItemSelected(items[item.index]);
    }

    setMenuVisible(false);
  }

  const appliedPopperStyles = {
    ...styles.popper,
    // marginLeft: '60px', //'35px',
    /*paddingTop: 10*/
    // marginTop: 7,

  };

  function buttonClick() {
    if (!clickForMenuCloseRef.current)
      setMenuVisible(!menuVisible);

    deleteAllTooltipsFromDom();
  }

  // const onActionButtonClick = action === 'click'
  //   ? () => setMenuVisible(!menuVisible)
  //   : undefined;

  //onContextMenu?
  // const onActionButtonRightClick = action === 'rightClick'
  //   ? (e:MouseEvent) => {
  //     setMenuVisible(!menuVisible);
  //     e.stopPropagation();
  //     e.preventDefault();
  //   }
  //   : undefined;

  /* reformat array by separator. This is done because of avoiding changes in tons of files. */
  const formatterItems = useMemo(() => splitMenuItemsIntoSections(items), [items])

  // let userEmail = '';
  // if (user) {
  //   if (user.department) {
  //     userEmail = `${user.email} - ${user.departmentName}`;
  //   } else {
  //     userEmail = user.email ?? '';
  //   }
  // }

  const userEmail = appContext.user ? appContext.user.id ?? '' : '';

  function deleteAllTooltipsFromDom() {
    const visibleTooltips = document.querySelectorAll('.ifms-tooltip');
      if (visibleTooltips && visibleTooltips.length > 0) {
        for (let i = 0; i < visibleTooltips.length; ++i) {
          const t = visibleTooltips[i];
          if (t.parentElement) {
            t.parentElement.removeChild(t);
          }
        }
      }
  }
  function getDbNameWithSuntekId() {
    //<pt231216: [userid-login]
    //const authService = new AuthService();
    // const licProduct:LicProduct = authService.getUserLicProduct();

    // return `${licProduct.database_DBName??''} (${licProduct.licID})`;
    return user === null ? "" : <p id='user-button-database'>{user.defaultDatabase?.toUpperCase()??''}<br/>({user.suntekId})</p>;
    //pt231216>
  }

  return (
    <div style={{ display: 'flex', width: '40px', justifyContent: 'end' }} >
      <DashboardCustomButton id='user-button' ref={buttonRef}  data-tooltip={userEmail} data-tooltip-position = {'user-button'} onClick={buttonClick}>
        <LetteredAvatar name={userState.user?.id??"**"} />
      {/* <img height="18px" src={menuVisible ? userImageSelected : userImage} style={{ position: 'relative', top: '-1px' }}/> */}
        {/* {!!userState.user?.userIcon
          ?
          <div style={{ borderRadius: '70%', height: '24px', width: '25px', overflow: 'hidden' }}>
            <img style={{ height: '100%', width: '100%', objectFit: 'cover' }} src={userState.user?.userIcon} alt='' />
          </div>
          :
          <img height="25px" style={{ position: 'relative' }} src={menuVisible ? userImageSelected : userImage} alt='' />
        } */}
        <span ref={setReferenceElement}></span>
      </DashboardCustomButton>
      {/* <div style={{
        display: 'flex',
        alignItems: 'center',
        fontSize: '11px',
        maxWidth: '165px',
        marginLeft: '5px',
        marginTop: '15px',
        color: !appContext.useDarkMode ? 'black' : 'white',
        fontWeight: !appContext.useDarkMode ? 'normal' : 'bold',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
      }}>
        {getDbNameWithSuntekId()}
      </div> */}
      <Portal node={document && document.getElementById('ifms-app-bottom')}>
        {menuVisible &&
          <div
            onMouseMove={(e) => {e.stopPropagation()}}
            ref={setPopperElement} style={appliedPopperStyles} {...attributes.popper}>
            <div ref={menuContainerRef}>
              <Menu
                specialMenu='user'
                items={formatterItems}
                mode="vertical"
                onMenuItemSelected={onMenuItemSelected}
                subMenuStyle={{
                  backgroundColor:'#B4EBF6',
                  minWidth: '100px',
                  whiteSpace: 'nowrap',
                  borderRadius: '13px',
                  border: '2px solid #0279A4',
                  boxShadow: '0px 0px 1px 1px #7DB1BF',
                }}
                menuStyle={(i: number) => ({
                  //overflowY: 'hidden',
                  //padding: 0,
                  //borderTop: `3px solid ${borderColors[i % borderColors.length]}`,
                  //paddingTop: 10,
                  marginTop: -11,
                  marginBottom: -12,
                })}
              />
              <div ref={setArrowElement} style={styles.arrow} />
            </div>
          </div>
        }
      </Portal>
    </div>
  );
}

ActionButton.defaultProps = {
  action: 'hover',
  onItemSelected: () => {},
  variant: 'plain',
};

ActionButton.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    separator: PropTypes.bool,
  })),
  action: PropTypes.oneOf(['click', 'hover', 'rightClick']).isRequired,
  onItemSelected: PropTypes.func.isRequired,
  height: PropTypes.string,
  variant: PropTypes.oneOf(['plain', 'highlight']).isRequired,
};

export default React.memo(ActionButton);
